import React from "react";
import {ProfilePage} from "../../profile/ProfilePage";
import {CustomerSubPageLayout} from "../../layouts/customerLayout/customerSubPageLayout/CustomerSubPageLayout";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

const CustomerProfilePage = () => {
    return (
        <CustomerSubPageLayout options={{showCodPaymentMethodSelectionLayer: false}}>
            <CustomerMenuHeader />
            <ProfilePage />
        </CustomerSubPageLayout>
    );
};

export default CustomerProfilePage;
